import useCurrentUserBidsAndAsks from 'src/hooks/useCurrentUserBidsAndAsks';
import useOrderbookDisplayStore from './useOrderbookDisplayStore';
import { useEffect } from 'react';

export const useSyncCurrentUserBidsAndAsks = () => {
	const setCurrentUserBidsAndAsks = useOrderbookDisplayStore(
		(s) => s.setCurrentUserBidsAndAsks
	);
	const { currentMarketBidsAndAsks } = useCurrentUserBidsAndAsks();

	// Update current user bids and asks
	useEffect(() => {
		setCurrentUserBidsAndAsks(currentMarketBidsAndAsks);
	}, [currentMarketBidsAndAsks, setCurrentUserBidsAndAsks]);
};
